import React from 'react';
import { connect } from 'react-redux';

import { Table } from 'reactstrap';
import './styles.scss';
import { defaultUnits } from '@config';
import { unitTransform, prepareNum } from '@services/helper.service';
import { APP_TEXTS } from '../../../../texts/texts';

const CalculateLoads = props => (
  <div className="calculation">
    <section className="list-type calculate-loads">
      <span>{APP_TEXTS.CALCULATE_LOADS_ON_ANCHORS.Content}</span>
      <Table bordered size="sm">
        <thead>
          <tr>
            <th>{APP_TEXTS.CALCULATE_LOADS_ANCHOR.Content}</th>
            <th>{APP_TEXTS.CALCULATE_LOADS_TENSILE.Content}</th>
            <th>{APP_TEXTS.CALCULATE_LOADS_SHEAR_X.Content}</th>
            <th>{APP_TEXTS.CALCULATE_LOADS_SHEAR_Y.Content}</th>
          </tr>
        </thead>
        <tbody>
          {props.anchorResults && props.anchorResults.map(item => (
            <tr key={item.Index}>
              <th scope="row">{item.Index}</th>
              <td>{prepareNum(unitTransform(+item.N1 || 0).from(defaultUnits.LOAD).to(props.loadUnit), false)}</td>
              <td>{prepareNum(unitTransform(+item.Vx1 || 0).from(defaultUnits.LOAD).to(props.loadUnit), false)}</td>
              <td>{prepareNum(unitTransform(+item.Vy1 || 0).from(defaultUnits.LOAD).to(props.loadUnit), false)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </section>
  </div>
);

const mapState = state => {
  const data = state.selectors.calculate[state.main.appType];

  if (data && data.gridSelectedItem) {
    return {
      anchorResults: data.gridSelectedItem.AnchorResults,
      loadUnit: state.main.units.load
    };
  }

  return {};
};

export default connect(mapState)(CalculateLoads);



// WEBPACK FOOTER //
// ./src/views/Calculate/components/CalculateLoads/index.js